export default {
  url_list: `/file_manager/?action=list`,
  url_create_folder: `/file_manager/?action=create-dir`,
  url_get_content: `/file_manager/?action=download`,
  url_download: `/file_manager/?action=download`,
  url_upload: `/file_manager/?action=upload`,
  url_remove: `/file_manager/?action=remove`,
  url_zip: `/file_manager/?action=zip`,
  url_unzip: `/file_manager/?action=unzip`,

  url_rename: `/file_manager/?action=rename`,
  url_move: `/file_manager/?action=move`,
  url_copy: `/file_manager/?action=copy`,
  url_edit: `/file_manager/file/edit`,
  url_compress: `/file_manager/items/compress`,
  url_extract: `/file_manager/file/extract`,

  isEditableFilePattern:
    /\.(txt|diff?|patch|svg|asc|cnf|cfg|conf|html?|cfm|cgi|aspx?|ini|pl|py|md|css|cs|jsx?|jsp|log|htaccess|htpasswd|gitignore|gitattributes|env|json|atom|eml|rss|markdown|sql|xml|xslt?|sh|rb|as|bat|cmd|cob|for|ftn|frm|frx|inc|lisp|scm|coffee|php[3-6]?|java|c|cbl|go|h|scala|vb|tmpl|lock|go|yml|yaml|tsv|lst)$/i,
  isImageFilePattern: /\.(jpe?g|gif|bmp|png|svg|tiff?)$/i,
  isExtractableFilePattern: /\.(gz|tar|rar|g?zip)$/i,

  actions: {
    create_folder: true,
    move: true,
    copy: true,
    copy_folder: true,
    compress: true,
    extract: true,
    edit: true,
    remove: true,
    upload: true,
    upload_by_chunks: true,
    preview_images: true,
  },
};
